import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LocalStorageManager } from '../../../utils/local-storage-manager/local-storage-manager.utils';

@Component({
  selector: 'app-modal-icon-selector',
  templateUrl: './modal-icon-selector.component.html',
  styleUrls: ['./modal-icon-selector.component.css']
})
export class ModalIconSelectorComponent {

  @Input() modalId: string = "app-modal-icon-selector";

  @Output() selectedIcon = new EventEmitter<string>();

  isDarkmode = LocalStorageManager.isDarkmode;

  icons: Icons[] = [];
  constructor() {
    this.generateInterfaceIcons();
  }

  generateInterfaceIcons(){
    this.pushInterface("Activities","img_activity_", 22);
    this.pushInterface("Banks","img_bank_", 4);
    this.pushInterface("Buildings","img_building_", 17);
    this.pushInterface("Cards","img_card_", 15);
    this.pushInterface("Clothings","img_clothing_", 27);
    this.pushInterface("Devices","img_device_", 28);
    this.pushInterface("Drinks","img_drink_", 24);
    this.pushInterface("Family","img_family_", 26);
    this.pushInterface("Food","img_food_", 24);
    this.pushInterface("Games","img_game_", 21);
    this.pushInterface("Money","img_money_", 65);
    this.pushInterface("Party","img_party_", 26);
    this.pushInterface("People","img_people_", 65);
    this.pushInterface("Pet","img_pet_", 9);
    this.pushInterface("Service","img_service_", 21);
    this.pushInterface("Sport","img_sport_", 24);
    this.pushInterface("Symbol","img_symbol_", 18);
    this.pushInterface("Transport","img_transport_", 39);
    this.pushInterface("Streaming","img_streaming_", 20);
  }

  pushInterface(groupName: string, prefixIconName: string, lengthArray: number){
    let iconsNames: string[] = [];
    for (let i = 1; i <= lengthArray; i++) {
      let name = prefixIconName; 
      name = i <= 9 ?  name += "0"+i : name += i;  
      iconsNames.push(name);
    }
    var iconGroup: Icons = {groupName, iconsNames};
    this.icons.push(iconGroup)
  }

  selectIcon(iconName: string) {
    this.selectedIcon.emit(iconName);
  }
}

interface Icons {
  groupName: string;
  iconsNames: string[];
}